import Graph from './Component';

export default Graph;
